import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react';
import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const TeamsDetailsModal = ({ isOpen, onClose, team }) => {
    const [data, setData] = useState([]);
    const user = useSelector((state) => state.user.userData);
    // console.log("team", team)

    const showTeamUsers = useCallback(async () => {
        try {
            const response = await axios.get(`http://18.132.190.48:8080/api/v1/getAllUser/team?userId=${user.userId}&teamId=${team.teamId}`);
            setData(response.data);
        } catch (error) {
            console.log(error);
        }
    }, [user.userId, team.teamId]);

    useEffect(() => {
        if (team) {
            showTeamUsers();
        }
    }, [team, showTeamUsers]);

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="xs">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Team Details</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    {data.map((e) => (
                        <Text key={e.empId}>{e.fullname}</Text>
                    ))}
                </ModalBody>
                <ModalFooter>

                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default TeamsDetailsModal;
